import React from 'react';
import styled from 'styled-components/macro';
import useMobileNavAPI from '../../hooks/useMobileNavAPI';
import { Sizes } from '../layouts/ng-layouts/Containers';
import _DontPrint from '../../internal-components/DontPrint';
import _BackButton from '../BackButton';

const NavBar = styled.div`
  background: #fff;
  height: ${Sizes.MOBILE_NAV_BAR_HEIGHT}px;
  // width: calc(100vw - 14px);
  width: 100vw;
  z-index: 10;
  display: flex;
  align-items: center;
  padding: 0 12px;
  box-shadow: 5px 10px 12px -19px black;
`;

const PageName = styled.span`
  margin: auto;
  font-weight: 600;
`;

const DontPrint = styled(_DontPrint)`
  position: sticky;
  top: 0;
  z-index: 10;
  flex: 0 1 auto;
`;

const BackButton = styled(_BackButton)`
  && {
    position: absolute;
  }
`;

const NavBarMobileView = props => {
  const { title, useBackBtn } = useMobileNavAPI();
  return (
    <DontPrint>
      <NavBar>
        {useBackBtn ? <BackButton /> : null}
        <PageName>{title || props.getBtnDisplayName(props.pageId)}</PageName>
      </NavBar>
    </DontPrint>
  );
};

export default NavBarMobileView;
